const productInformationExpand = () => {
  const expandWrapper = document.querySelector('.product-expand')
  const expandTrigger = document.querySelector('.product-expand-trigger')

  if (expandWrapper && expandTrigger) {
    const expandWrapperHeight = expandWrapper.offsetHeight
    if (expandWrapperHeight > 340) {
      expandWrapper.classList.add('max-h-340')
      expandTrigger.parentNode.classList.remove('hidden')
    }

    expandTrigger.addEventListener('click', () => {
      expandWrapper.classList.add('is-expanded')
      expandTrigger.parentNode.classList.add('hidden')
    })
  }
}

export default productInformationExpand
